import React, { useEffect, useState } from 'react';
import DashboardLayout from '../components/dashboard/DashboardLayout';
import { supabase } from '../lib/supabase';

const Resources = () => {
    const [resources, setResources] = useState([]);

    useEffect(() => {
        const fetchResources = async () => {
            //setLoading(true)
            //setError(null)
    
            // Get current user from Supabase auth
            const { data: { user } } = await supabase.auth.getUser()
            if (!user) throw new Error('No user found')
    
            const { data, error } = await supabase
              .rpc('get_user_resources_by_access_level', {
                lookup_user_id: user.id
              })
    
            if (error) {
                console.error('Error fetching resources:', error);
            } else {
                setResources(data);
            }
        };

        fetchResources();
    }, []);

    return (
        <DashboardLayout>
            <div className="max-w-5xl mx-auto px-6 py-12">
                <div className="mx-auto mb-12">
                    <img 
                        src="/images/hero-resources.png" 
                        alt="Person working at desk with various documents"
                        className="w-full mx-auto mb-8"
                    />
                    <div className="text-sm text-gray-600 mb-2">
                        IN THIS SECTION
                    </div>
                    <h2 className="text-xl font-medium mb-8">
                        Welcome to the resource advantage where better, faster job placement happens. Let's cover all the things you need to know to get ahead. These resources are designed to be used <i>in order.</i>
                    </h2>
                </div>
                <h1 className="text-4xl font-bold mb-12">Resources</h1>
                <div className="space-y-3">
                    {resources.map((resource, index) => (
                        <div key={index} className="flex items-start gap-4 pb-6">
                            <a href={resource.url_to_content} className="flex-shrink-0">
                                <div className="w-[275px] h-[140px] bg-gray-50 rounded-lg border border-gray-200 overflow-hidden">
                                    <img 
                                        src={resource.url_to_thumbnail} 
                                        alt="" 
                                        className="w-full h-full p-6"
                                    />
                                </div>
                            </a>
                            <div className="pt-1">
                                <a 
                                    href={resource.url_to_content}
                                    className="text-lg font-medium text-gray-800 hover:text-blue-600"
                                >
                                    {resource.name}
                                </a>
                                <p className="text-md text-gray-600 mt-1">
                                    {resource.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </DashboardLayout>
    );
};

export default Resources;